import {makeExpandedLabelValues} from "../../helpers/make-expanded-label-values";
import {FunctionComponent} from "react";
import styles from './ChartLabelExpanded.module.css';
import {AllowedColours} from "../../data/colours";

export interface ChartLabelExpandedProps {
    val: number,
    oldVal: number,
    color: AllowedColours,
    isLast?: boolean,
    alignRight?: boolean,
}

const ChartLabelExpanded: FunctionComponent<ChartLabelExpandedProps> = ({val, oldVal, color, isLast, alignRight}) => {
    const {
        changeString,
        barWidthOld,
        barWidthNew,
        offsetOld,
        offsetNew,
        bgWidth,
    } = makeExpandedLabelValues(val, oldVal);

    const offsetLeftDenominator = isLast ? 1.75 : 4;
    const rightOffset = alignRight ? "25%" : undefined;

    return (<>
        <defs>
            <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
                <feOffset dx="5" dy="2"/>
                <feGaussianBlur result="blur" stdDeviation="3"/>
                <feFlood floodColor="#000" floodOpacity=".15"/>
                <feComposite in2="blur" operator="in"/>
                <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g className={styles.legendExpanded}
           style={{transform: `translate(${rightOffset || `-${bgWidth / offsetLeftDenominator}px`}, -3px)`}}>
            <g>
                <rect
                    className={styles.legendSvgExpanded8}
                    x="4.48"
                    y="7.81"
                    width={bgWidth}
                    height="53.89"
                    rx="16"
                    ry="16"
                />
                <g>
                    <text
                        className={styles.legendSvgExpanded2}
                        transform={`translate(${offsetNew(110.09)} 29.85)`}
                        fill={color}
                    >
                        <tspan x="0" y="0">{val}%</tspan>
                    </text>
                    <text
                        className={styles.legendSvgExpanded3}
                        transform={`translate(${offsetNew(144.66)} 29.18)`}
                        fill={color}
                    >
                        <tspan x="0" y="0">({changeString})</tspan>
                    </text>
                    <text
                        className={styles.legendSvgExpanded4}
                        transform="translate(17.37 29.94)"
                        fill={color}
                    >
                        <tspan x="0" y="0">2022</tspan>
                    </text>
                    <rect
                        className={styles.legendSvgExpanded1}
                        x="56.97"
                        y="20.93"
                        width={barWidthNew}
                        height="9"
                        fill={color}
                    />
                </g>
                <g>
                    <text className={styles.legendSvgExpanded6} transform={`translate(${offsetOld(97.1)} 49.84)`}>
                        <tspan x="0" y="0">{oldVal}%</tspan>
                    </text>
                    <text className={styles.legendSvgExpanded7} transform="translate(17.37 49.92)">
                        <tspan x="0" y="0">2021</tspan>
                    </text>
                    <rect className={styles.legendSvgExpanded5} x="56.97" y="40.89" width={barWidthOld}
                          height="9"/>
                </g>
            </g>
        </g>
    </>);
}

export default ChartLabelExpanded;